import { useQuery } from "@tanstack/react-query";
import * as productService from "@features/products/services/productService";
import { useParams, useNavigate } from "react-router-dom";
import { ProductForm } from "@features/products/components/ProductForm";
import { useProducts } from "@features/products/hooks/useProducts";
import { useState } from "react";
import { toast } from "sonner";
import ThreeDotLoader from "@shared/components/ThreeDotLoader";
import HeadLayout from "@shared/layouts/HeadLayout";
import { useTranslation } from "react-i18next";

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { updateProduct } = useProducts();
  const { t } = useTranslation();
  const [isUpdated, setIsUpdated] = useState(false);

  const { data: product, isLoading } = useQuery({
    queryKey: ["products", id],
    queryFn: () => productService.fetchProductByID(id),
    enabled: !!id && !isUpdated,
  });

  const handleUpdateProduct = (values) => {
    setIsUpdated(true);
    updateProduct(
      { id, values },
      {
        onSuccess: () => {
          setIsUpdated(false);
          toast.success(`Product updated ${values.name}`);
          navigate("/products");
        },
        onError: (error) => {
          setIsUpdated(false);
          toast.error(error.response.data.message);
        },
      }
    );
  };

  if (isLoading) {
    return <ThreeDotLoader />;
  }

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <>
      <HeadLayout title={t("products.editProduct")} />
      <div className="bg-background p-4 rounded-xl">
        <ProductForm
          initialData={product}
          action="update"
          onSubmit={handleUpdateProduct}
          isloading={isUpdated}
        />
      </div>
    </>
  );
};

export default EditProduct;
